module.exports = __webpack_public_path__ + "fonts/88c901be7434d05291b2b6166ef81f40.txt";